<div class="flex gap-2 justify-end">
  <a panButton color="primary" icon="arrow_forward" [routerLink]="['/shared/report', params.data.id]"> </a>

  <app-pan-button data-testid="report-history-button" color="info" icon="history" (click)="params.historyCallback(params.data)"> </app-pan-button>

  @if (params.data.category !== "Shared") {
    <app-pan-button color="danger" icon="delete" [swal]="removeItemSwal"> </app-pan-button>

    <swal
      #removeItemSwal
      title="Remove Report?"
      text="Are you sure you want to remove the report {{ params.data.name }}?"
      icon="warning"
      confirmButtonText="Yes, Remove"
      [showCancelButton]="true"
      [focusCancel]="true"
      (confirm)="params.removeCallback(params.data)"
    >
    </swal>
  }
</div>
